import React from 'react'
import a23logo from "../assets/a23_avatar_logo.png"
import closeIcon from '../assets/close.png';
import { toggleModalAction } from '../redux/actions/userAction';
import { useDispatch } from 'react-redux';
import { WebToNativeMessage } from '../Common/Utils';
import NewClose from "../assets/revamp-assets/closeMark.png";
import NewLogo from "../assets/newLogo.svg"
import AddaLogo from "../assets/Adda52_popup_logo.png"
// sessionStorage.getItem("channel") === 'OEMAPS1'

export default function PremiumAccess() {

    const dispatch = useDispatch()

    return (
        <div id="pPopup" className='premiumPopup' style={{ textAlign: 'center', paddingBottom: '20px', backgroundColor: (sessionStorage.getItem("channel") === 'poker2android' || sessionStorage.getItem("channel") === 'poker2ios' || sessionStorage.getItem("channel") === 'poker2freerollAndroid') ? '#ecf0f3':"rgb(255, 253, 234)", position: 'relative', padding: '2.5rem 2rem 1rem 2rem', borderRadius: '10px' }}>
            <div style={{ width: '50px', position: 'absolute', top: '-25px', left: '50%', transform: 'translate(-50%)' }}>
                <img style={{ width: '100%' }} 
                // src={ sessionStorage.getItem("channel") === 'OEMAPS1' ? NewLogo :a23logo}
                src={ (sessionStorage.getItem("channel").toLowerCase() === 'poker2android' || sessionStorage.getItem("channel").toLowerCase() === 'poker2ios' || sessionStorage.getItem("channel").toLowerCase() === 'poker2freerollAndroid') ? AddaLogo :a23logo}
                ></img>
            </div>
            <div className="infoHeader">
                <img 
                src={ sessionStorage.getItem("channel") === 'OEMAPS1' ? NewClose :closeIcon} className="closeButton" style={{width:"15px",height:"15px"}} onClick={() => dispatch(toggleModalAction(false))}></img>
            </div>
            {/* className="infoTitle"  */}
            <div className='premiumAccessPopupTitle'>
                {/* <span style={{fontWeight: 'bold'}}>Premium Access</span> */}
                <span style={{fontWeight: 'bold'}}>Request failed!</span>
            </div>
            <div className="infoItself">
                {/* <p className="infoText infoTextPremium" >
                    This feature is available only for premium players. <br></br>
                    Add cash now for a premium gaming experience on A23.
                </p> */}
                <p className="infoText infoTextPremium" >
                    We are not able to initiate your withdrawal request. <br></br>
                    Please reach out to our customer care.
                </p>
            </div>
            <div className='btnDiv' style={{ display: 'flex', justifyContent: 'center' }}>
                <button className='addCashBtn btnStyle'
                    onClick={() => {
                        // WebToNativeMessage({
                        //     type: "redeemCTEvent", eventName: "AddCashClick", eventProperties: {
                        //         clickLocation: "wallet",
                        //         username: window.sessionStorage["screenName"]
                        //     }
                        // })
                        // WebToNativeMessage({ type: "openAddCash", token: window.sessionStorage["token"], from: "" })
                        // WebToNativeMessage({ type: "openAddCash", token: window.sessionStorage["token"], from: "" })
                         WebToNativeMessage({ type: "email" })
                    }}>
                    {/* Add Cash */}
                    Email Us
                </button>
            </div>
        </div >
    )
}